module.exports = __webpack_public_path__ + "static/img/blocked.d4b98339.png";